import React from 'react'

const IconAutorun = ({ width = '48', height = '34' }) => (
  <svg
    width={`${width}px`}
    height={`${height}px`}
    viewBox={`0 0 ${width} ${height}`}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(0.000000, -7.000000)" fill="currentColor" fillRule="nonzero">
        <path d="M32,39 L32,41 L16,41 L16,39 L32,39 Z M48,7 L48,37 L0,37 L0,7 L48,7 Z M46,9 L2,9 L2,35 L46,35 L46,9 Z M34.3003937,18.1319892 C34.7611133,19.3583435 35,20.6634891 35,22 C35,28.0751322 30.0751322,33 24,33 C21.6554002,33 19.421658,32.2631093 17.5678032,30.9243773 L16.5927249,31.8996914 L15.7284832,27.5784832 L20.0496914,28.4427249 L19.0044785,29.4877311 C20.4663881,30.4656423 22.1912077,31 24,31 C28.9705627,31 33,26.9705627 33,22 C33,21.0263411 32.845697,20.0751297 32.5469411,19.1718073 L32.4281557,18.8353558 L34.3003937,18.1319892 Z M24,11 C26.2854346,11 28.465269,11.7002207 30.2902348,12.9747831 L31.2654541,12 L32.1296958,16.3212081 L27.8084877,15.4569665 L28.8490913,14.4163452 C27.4193263,13.4996573 25.7489822,13 24,13 C19.0294373,13 15,17.0294373 15,22 C15,22.9868669 15.1585213,23.9506425 15.465248,24.8647863 L15.5871975,25.205212 L13.7183989,25.9176667 C13.2454255,24.6770379 13,23.3546685 13,22 C13,15.9248678 17.9248678,11 24,11 Z M21,18.5 L28,22 L21,25.5 L21,18.5 Z" />
      </g>
    </g>
  </svg>
)

export default IconAutorun
